<template>
  <section class="cl-black categories" :class="{ 'not-location': !currentLocation }">
    <div v-if="getDecoration && Object.keys(getDecoration).length">
      <let-it-snow :show="show" v-bind="getDecoration.key === 'snowflakes' ? snowConf : valentineConf"/>
    </div>
    <div class="container p15">
      <div class="home-location-none py20 col-md-12" v-if="!currentLocation">
        <div class="image-location desktop">
          <picture>
            <source srcset="/assets/home-location.webp" type="image/webp">
            <source srcset="/assets/home-location.png" type="image/jpeg">
            <img src="/assets/home-location.png" width="591" height="289" alt="Service for delivery of products" loading="eager" fetchpriority="high">
          </picture>
        </div>
        <div class="home-location">
          <h1 class="light home-location-text-top">{{ $t('We will deliver everything you need') }}</h1>
          <p class="home-location-text-bottom">{{ $t('Delivery of products and not only. Supermarkets, shops, restaurants on one site.') }}</p>
          <locations-list />
        </div>
        <div class="image-location mobile">
          <picture>
            <source srcset="/assets/home-location.webp" type="image/webp">
            <source srcset="/assets/home-location.png" type="image/jpeg">
            <img src="/assets/home-location.png" width="591" height="289" alt="Service for delivery of products" loading="eager" fetchpriority="high">
          </picture>
        </div>
      </div>
      <div v-else>
        <bounce-loader style="margin-bottom: 40px" v-if="loader"/>
        <div v-else>
          <div class="col-md-12 col-xs-12 p0" v-if="banners && banners.length">
            <promotion-slider :banners="banners" class="mb20"/>
          </div>
          <template v-if="currentLocation && currentLocation.layout_code === 'categories_only' && getCategories.length">
            <div slot="content" class="row center-xs category-card-container"  v-if="getCategories.length > 0">
              <category-card v-for="(category, index) in getCategories" :key="index" :lcp="index === 0" :mobileFlower="getCategories.length < 8" :category="category" />
            </div>
          </template>
          <template v-else-if="currentLocation && currentLocation.layout_code === 'partners_only' && partners.length">
            <partners-list />
          </template>
          <template v-else>
            <home-wait-partners/>
          </template>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import HomeCategoryCard from 'theme/components/theme/blocks/Partners/HomeCategoryCard'
import HomeLocationsList from 'theme/components/theme/blocks/Locations/HomeLocationsList'
import HomeStore from 'theme/components/core/blocks/Switcher/HomeStore'
import BounceLoader from 'theme/components/theme/blocks/Home/Preloaders/BounceLoader'
import LetItSnow from 'vue-let-it-snow'
import HomeWaitPartners from '../../../theme/blocks/Partners/HomeWaitPartners.vue';

const PromotionSlider = () => import(/* webpackChunkName: "vsf-promotion-slider" */ 'theme/components/core/PromotionSlider');

export default {
  components: {
    'category-card': HomeCategoryCard,
    'locations-list': HomeLocationsList,
    'partners-list': HomeStore,
    BounceLoader,
    LetItSnow,
    PromotionSlider,
    HomeWaitPartners
  },
  data () {
    return {
      snowConf: {
        windPower: 1,
        speed: 1,
        count: 20,
        size: 10,
        opacity: 1,
        images: [
          '/assets/let-in-snow/snow.png',
          '/assets/let-in-snow/sock.png',
          '/assets/let-in-snow/tree.png',
          '/assets/let-in-snow/delivery.png',
          '/assets/let-in-snow/shopping.png',
          '/assets/let-in-snow/application.png'
        ]
      },
      valentineConf: {
        windPower: 1.2,
        speed: 1.2,
        count: 20,
        size: 5,
        opacity: 0.7,
        images: [
          '/assets/let-in-snow/cupid-arrow.png',
          '/assets/let-in-snow/flower-bouquet.png',
          '/assets/let-in-snow/wedding-dinner.png',
          '/assets/let-in-snow/shopping-bag.png',
          '/assets/let-in-snow/chocolate.png',
          '/assets/let-in-snow/love.png',
          '/assets/let-in-snow/wedding-day.png',
          '/assets/let-in-snow/chocolate.png',
          '/assets/let-in-snow/chocolate-box.png'
        ]
      },
      show: false
    }
  },
  computed: {
    ...mapGetters({
      getCategories: 'partner_categories/getCategories',
      currentLocation: 'locations/getActiveLocation',
      loader: 'ui/getLoader',
      currentPartner: 'partners/getCurrentPartner',
      getSeasonalDecoration: 'configs/getSeasonalDecoration',
      partners: 'partners/getPartnersByLocation'
    }),
    banners () {
      return this.currentLocation ? this.currentLocation.promotions : []
    },
    getDecoration () {
      return this.getSeasonalDecoration && this.getSeasonalDecoration.length ? this.getSeasonalDecoration.find(s => s.value) : {}
    }
  },
  methods: {
    ...mapActions({
      resetPartner: 'partners/resetCurrentPartner',
      resetPartners: 'partners/clearPartners',
      ensureCategories: 'partner_categories/ensureCategories'
    })
  },
  mounted () {
    if (this.getDecoration && Object.keys(this.getDecoration).length) {
      this.show = !!this.getDecoration.value
    }
    this.ensureCategories({ locationCode: this.currentLocation && this.currentLocation.code })
    this.resetPartner()
    if (this.currentLocation && this.currentLocation.layout_code !== 'partners_only') this.resetPartners()
  },
}
</script>
<style lang="scss" scoped>

  .category-card-container {
    min-height: 245px;
    @media (max-width: 1200px) {
      min-height: 201px;
    }
    @media (max-width: 991px) {
      min-height: 226px;
    }
    @media (max-width: 576px) {
      min-height: auto;
    }
  }
  .light{
    font-family: 'TTNorms Light', sans-serif;
  }
  .home-location-none{
    display: flex;
    @media (max-width: 1200px) {
      display: block;
    }
  }
  .home-location{
    padding-top: 40px;
    margin: 10px 0;
    padding-left: 55px;
    flex-basis: 50%;
    max-width: 50%;
    @media (max-width: 1200px) {
      flex-basis: 100%;
      max-width: 100%;
      text-align: center;
      padding-top: 0;
    }
    @media (max-width: 990px) {
      padding-left: 0;
    }
  }
  .image-location{
    flex-basis: 50%;
    max-width: 50%;
    @media (max-width: 1200px) {
      flex-basis: 100%;
      max-width: 100%;
      text-align: center;
    }
    img{
      @media (max-width: 768px) {
        width: 100%;
      }
    }
  }
  .home-location-text-top{
    font-size: 36px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.23px;
    margin: 0;
    @media (max-width: 768px) {
      font-size: 30px;
    }
  }
  .home-location-text-bottom{
    font-size: 21px;
    margin: 10px 0;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.13px;
    color: #111111;
    @media (max-width: 768px) {
      font-size: 16px;
    }
  }
  .not-location{
    background: #fff4dd;
  }
  .desktop{
    @media (max-width: 1200px) {
      display: none;
    }
  }
  .mobile{
    display: none;
    @media (max-width: 1200px) {
      display: block;
    }
  }
</style>
